import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import logo from "../../assets/logoS.png";

const Footer = () => {
  const links = ["Services", "About", "Equipment", "Treatments", "Contact"];
  const socials = [
    { name: "Instagram", url: "https://www.instagram.com/elaia.aesthetic" },
    // { name: "Facebook", url: "https://www.facebook.com/elaia.aesthetic" },
    { name: "TikTok", url: "https://www.tiktok.com/@elaia.aesthetic" },
  ];

  return (
    <FooterEl>
      <TopBorder />
      <Inner>
        <LogoCol>
          <Logo src={logo} alt="Elaia Aesthetic" />
          <Tagline>Where Science Meets Beauty, Refined.</Tagline>
          <Socials>
            {socials.map((s) => (
              <SocialLink
                key={s.name}
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                as={motion.a}
                whileHover={{ color: "var(--rose)" }}
              >
                {s.name}
              </SocialLink>
            ))}
          </Socials>
        </LogoCol>

        <NavCol>
          <ColTitle>Navigim</ColTitle>
          {links.map((l) => (
            <FootLink key={l} href={`#${l.toLowerCase()}`}>
              {l}
            </FootLink>
          ))}
        </NavCol>

        <NavCol>
          <ColTitle>Shërbimet</ColTitle>
          {[
            "Deep Cleansing",
            "HydraFacial",
            "Dermapen",
            "Peeling Kimik",
            "Ultra Contour Touch",
            "Maderoterapia",
            "Body Combo 10",
            "VF 100",
          ].map((t) => (
            <FootLink key={t} href="#services">
              {t}
            </FootLink>
          ))}
        </NavCol>

        {/* <ContactCol>
          <ColTitle>Na Vizitoni</ColTitle>
          <ContactItem>[Adresa – Placeholder]</ContactItem>
          <ContactItem>[Qyteti, Shteti]</ContactItem>
          <ContactItem style={{ marginTop: "16px" }}>
            [Telefon – Placeholder]
          </ContactItem>
          <ContactItem>[Email – Placeholder]</ContactItem>
          <BookBtn href="#contact">Rezervo Tani</BookBtn>
        </ContactCol> */}
      </Inner>

      <BottomBar>
        <Copyright>
          © {new Date().getFullYear()} Elaia Aesthetic. Të gjitha të drejtat e
          rezervuara.
        </Copyright>
        <BottomLinks>
          <FootLink href="#">Politika e Privatësisë</FootLink>
          <FootLink href="#">Kushtet & Rregullat</FootLink>
        </BottomLinks>
      </BottomBar>
    </FooterEl>
  );
};

const FooterEl = styled.footer`
  background: #fadcb9;
  padding: 80px 0 0;
`;
const TopBorder = styled.div`
  height: 1px;
  background: linear-gradient(
    to right,
    transparent,
    rgba(196, 149, 122, 0.3),
    transparent
  );
  margin-bottom: 80px;
`;
const Inner = styled.div`
  max-width: 1300px;
  margin: 0 auto;
  padding: 0 60px;
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1.5fr;
  gap: 60px;
  align-items: start;
  @media (max-width: 1024px) {
    grid-template-columns: 1fr 1fr;
    gap: 40px;
  }
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
  @media (max-width: 768px) {
    padding: 0 24px;
  }
`;
const LogoCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-self: start;
`;
const Logo = styled.img`
  height: 90px;
  width: auto;
  object-fit: contain;
`;
const Tagline = styled.p`
  font-family: var(--font-display);
  font-size: 16px;
  font-style: italic;
  color: var(--taupe);
  margin: 0;
  line-height: 1.6;
  max-width: 240px;
`;
const Socials = styled.div`
  display: flex;
  gap: 24px;
  margin-top: 8px;
`;
const SocialLink = styled.a`
  text-decoration: none;
  font-family: var(--font-body);
  font-size: 11px;
  font-weight: 400;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  color: var(--taupe);
  transition: color 0.3s;
`;
const NavCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;
const ColTitle = styled.span`
  font-family: var(--font-body);
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.25em;
  text-transform: uppercase;
  color: var(--rose);
  margin-bottom: 8px;
`;
const FootLink = styled.a`
  text-decoration: none;
  font-family: var(--font-body);
  font-size: 13px;
  font-weight: 300;
  color: var(--taupe);
  transition: color 0.3s;
  &:hover {
    color: var(--cream);
  }
`;
const ContactCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const ContactItem = styled.span`
  font-family: var(--font-body);
  font-size: 13px;
  font-weight: 300;
  color: var(--taupe);
  line-height: 1.6;
`;
const BookBtn = styled.a`
  display: inline-block;
  margin-top: 16px;
  text-decoration: none;
  color: var(--charcoal);
  background: var(--rose);
  font-family: var(--font-body);
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  padding: 12px 28px;
  align-self: flex-start;
  transition: background 0.3s;
  &:hover {
    background: var(--gold);
  }
`;
const BottomBar = styled.div`
  max-width: 1300px;
  margin: 80px auto 0;
  padding: 24px 60px;
  border-top: 1px solid rgba(196, 149, 122, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
  @media (max-width: 768px) {
    padding: 24px;
  }
`;
const Copyright = styled.span`
  font-family: var(--font-body);
  font-size: 12px;
  color: rgba(138, 125, 115, 0.5);
  letter-spacing: 0.05em;
`;
const BottomLinks = styled.div`
  display: flex;
  gap: 24px;
`;

export default Footer;
